
    <main [ngClass]="{'menu-collapsed': isMenuCollapsed}" baThemeRun>
      <app-loader></app-loader>
      <div class="additional-bg"></div>
      <router-outlet></router-outlet>
    </main>